module.exports = "/10edfd4068d34c50b2112484a9ac70e4d00b19fd/be1537a45eb149bff6a9c4d7b38497e4.svg";